// src/pages/AboutPage.jsx
import React, { useState, useEffect } from 'react';

export default function AboutPage() {
    const [videoUrl, setVideoUrl] = useState('');
    
    // Đồng bộ API_URL giống với các component khác
    const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    useEffect(() => {
        const fetchVideo = async () => {
            try {
                // Sửa lại port 3001 và đường dẫn API cho khớp với backend
                const res = await fetch(`${API_URL}/api/admin/settings/about-video`);
                
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                
                const data = await res.json();
                if (data && data.videoUrl) {
                    setVideoUrl(data.videoUrl);
                }
            } catch (err) {
                console.error("Lỗi tải video:", err);
            }
        };
        fetchVideo();
    }, [API_URL]);

    return (
        <div style={{ backgroundColor: '#F8FAFC', minHeight: '100vh', paddingTop: '120px', paddingBottom: '80px' }}>
            <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 20px' }}>
                <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                    <h1 style={{ fontSize: '40px', fontWeight: '800', color: '#111827', marginBottom: '16px' }}>Về SkillMatch</h1>
                    <p style={{ fontSize: '18px', color: '#6B7280', maxWidth: '700px', margin: '0 auto' }}>
                        Nền tảng tuyển dụng công nghệ cao, giúp kết nối ứng viên và nhà tuyển dụng thông qua đánh giá năng lực thực tế.
                    </p>
                </div>

                {/* --- KHU VỰC HIỂN THỊ VIDEO TỪ CLOUDINARY --- */}
                {videoUrl && (
                    <div style={{ marginBottom: '60px', display: 'flex', justifyContent: 'center' }}>
                        <div style={{ 
                            width: '100%', 
                            maxWidth: '800px', 
                            borderRadius: '16px', 
                            overflow: 'hidden', 
                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', 
                            backgroundColor: '#000' 
                        }}>
                            <video 
                                width="100%" 
                                controls 
                                style={{ display: 'block' }}
                            >
                                <source src={videoUrl} type="video/mp4" />
                                Trình duyệt của bạn không hỗ trợ thẻ video.
                            </video>
                        </div>
                    </div>
                )}
                {/* ----------------------------------------- */}

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', marginBottom: '60px' }}>
                    <div style={{ background: 'white', padding: '40px', borderRadius: '24px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
                        <h2 style={{ color: '#2563EB', marginBottom: '16px' }}>Sứ mệnh</h2>
                        <p style={{ lineHeight: '1.7', color: '#4B5563' }}>
                            Chúng tôi tin rằng quy trình tuyển dụng nên dựa trên dữ liệu và kỹ năng thực tế thay vì chỉ qua bằng cấp hay cảm tính cá nhân.
                        </p>
                    </div>
                    <div style={{ background: 'white', padding: '40px', borderRadius: '24px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
                        <h2 style={{ color: '#2563EB', marginBottom: '16px' }}>Giá trị cốt lõi</h2>
                        <p style={{ lineHeight: '1.7', color: '#4B5563' }}>
                            Minh bạch, Chính xác và Hiệu quả là kim chỉ nam cho mọi tính năng mà chúng tôi phát triển trên hệ thống SkillMatch.
                        </p>
                    </div>
                    <div style={{ background: 'white', padding: '40px', borderRadius: '24px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
                        <h2 style={{ color: '#2563EB', marginBottom: '16px' }}>Dành cho Ứng viên</h2>
                        <p style={{ lineHeight: '1.7', color: '#4B5563', marginBottom: '20px' }}>
                            SkillMatch mang đến lộ trình phát triển sự nghiệp toàn diện, giúp bạn không chỉ tìm thấy công việc mơ ước mà còn nâng tầm kỹ năng bản thân:
                        </p>
                        <ul style={{ color: '#4B5563', lineHeight: '1.8', paddingLeft: '20px' }}>
                            <li><strong>AI CV Review:</strong> Tự động phân tích, chấm điểm và gợi ý sửa lỗi CV ngay lập tức để hồ sơ của bạn luôn nổi bật trong mắt nhà tuyển dụng.</li>
                            <li><strong>AI Mock Interview:</strong> Luyện tập phỏng vấn thực tế với các chuyên gia AI đa lĩnh vực, giúp bạn rèn luyện phản xạ và sự tự tin.</li>
                            <li><strong>AI Mentor & Lộ trình học:</strong> Dựa trên kết quả bài test năng lực, AI sẽ thiết kế lộ trình học tập cá nhân hóa để bạn cải thiện các kỹ năng còn yếu.</li>
                            <li><strong>Xác thực năng lực:</strong> Chứng minh kỹ năng thực tế thông qua các bài kiểm tra chuẩn hóa từ doanh nghiệp, giúp hồ sơ đạt độ tin cậy cao nhất.</li>
                        </ul>
                    </div>
                    <div style={{ background: 'white', padding: '40px', borderRadius: '24px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
                        <h2 style={{ color: '#2563EB', marginBottom: '16px' }}>Dành cho Nhà tuyển dụng</h2>
                        <p style={{ lineHeight: '1.7', color: '#4B5563', marginBottom: '20px' }}>
                            Chúng tôi thay đổi cách thức săn đón nhân tài bằng giải pháp tuyển dụng dựa trên dữ liệu thực tế, giúp doanh nghiệp tối ưu hóa nguồn lực:
                        </p>
                        <ul style={{ color: '#4B5563', lineHeight: '1.8', paddingLeft: '20px' }}>
                            <li><strong>Tuyển dụng không cảm tính:</strong> Loại bỏ sự cảm tính trong đánh giá nhờ hệ thống bài test năng lực thực tế và dữ liệu phân tích chuẩn xác.</li>
                            <li><strong>Sàng lọc ứng viên thông minh:</strong> Dễ dàng tìm kiếm và kết nối với nguồn nhân tài chất lượng cao đã được hệ thống xác thực kỹ năng chuyên môn.</li>
                            <li><strong>Tiết kiệm thời gian & chi phí:</strong> Quy trình từ đăng tin đến phỏng vấn được tối ưu hóa, giúp giảm thiểu 70% thời gian sàng lọc hồ sơ không phù hợp.</li>
                            <li><strong>Quản lý quy trình chuyên nghiệp:</strong> Theo dõi trạng thái ứng tuyển của ứng viên một cách minh bạch và đồng bộ trên cùng một nền tảng quản trị.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}